import { baseApi } from "api/BaseApi";

const crNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    triggerNotifyCrResponseReleased: build.mutation<void, { crid: number }>({
      query: (body) => ({
        url: "v2/notifications/cr-response-released/",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useTriggerNotifyCrResponseReleasedMutation } =
  crNotificationsApi;
